import React from 'react';
import Badge from '../Badge';
import { TbGift } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';

interface BadgeProductNoChargeableProps {
    product: any;
    className?: string;
}

const BadgeProductNoChargeable = ({
    product,
    className=''
}: BadgeProductNoChargeableProps) => {

    const { t } = useTranslation();

    if (product.chargeable) return null;

    return (
        <Badge className={`opacity-60 gap-0.5 leading-none py-1 ${className}`}>
            <TbGift size={12} className='shrink-0' />
            {t('products.chargeable')}
        </Badge>
    )
}

export default BadgeProductNoChargeable;
